/* istanbul ignore file */
export enum LinkType {
  LINK = 'link',
  PAGE = 'page',
  EVENT = 'event',
  DOCUMENT = 'document',
}
